import { justrite, lowstock, renimail, renistore, renitrust, wwo1, wwo2, wwo3 } from "../assets";
import { ICON_DASHBOARD, ICON_GIFT_FILL, ICON_MONEY_BILL, ICON_PEOPLE_ARROW, ICON_PEOPLE_FILL, ICON_WALLET, ICON_LINK, ICON_SETTING, ICON_HOME, ICON_PEOPLE, ICON_RECEIPT, ICON_BANK } from "../utils/icons";

// Homepage
// Nav Links
export const homeNavLink = [
    { title: "Home", to: "/" },
    { title: "What We Offer", to: "/#whatWeOffer" },
    { title: "Pricing", to: "/#pricing" },
    { title: "About Us", to: "about" },
    { title: "FAQs", to: "#" },
];

export const navLink = [
    { title: "Dashboard", name: "dashboard", to: "/user/dashboard", icon: ICON_DASHBOARD },
    { title: "Inventory", name: "inventory", to: "/user/inventory", icon: ICON_PEOPLE_ARROW },
    { title: "Invoice and Sales", name: "sales", to: "/user/sales", icon: ICON_GIFT_FILL },
    { title: "Waybill", name: "waybill", to: "/user/waybill", icon: ICON_GIFT_FILL },
    { title: "Business Banking", name: "banking", to: "/user/business-banking", icon: ICON_WALLET },
    { title: "Expenses", name: "expenses", to: "/user/expenses", icon: ICON_LINK },
    { title: "Customers", name: "customers", to: "/user/customers", icon: ICON_MONEY_BILL },
    { title: "Suppliers", name: "suppliers", to: "/user/suppliers", icon: ICON_PEOPLE_FILL },
    { title: "Debt Management", name: "debt", to: "/user/debt-management", icon: ICON_GIFT_FILL },
    { title: "Employees and Payroll", name: "staff", to: "/user/employees", icon: ICON_GIFT_FILL },
    { title: "Reports", name: "reports", to: "/user/reports", icon: ICON_SETTING },
    { title: "Settings", name: "settings", to: "/user/settings", icon: ICON_SETTING },
];

export const employeeNav = [
    { title: "Home", to: "/home", icon: ICON_HOME, name: 'dashboard' },
    { title: "Employee", to: "/staff", icon: ICON_PEOPLE, name: 'inventory' },
    { title: "Payroll", to: "/payroll", icon: ICON_RECEIPT, name: 'payroll' },
];

// Nav Links

// All the Features 
export const allFeatures = [
    { name: 'DASHBOARD', value: 'dashboard' },
    { name: 'EXPENSES', value: 'expenses' },
    { name: 'BUSINESS BANKING', value: 'banking' },
    { name: 'SALES & INVOICE', value: 'sales' },
    { name: 'WAYBILL', value: 'waybill' },
    { name: 'INVENTORY', value: 'inventory' },
    { name: 'CUSTOMERS', value: 'customers' },
    { name: 'SUPPLIERS', value: 'suppliers' },
    { name: 'DEBT MANAGEMENT', value: 'debt' },
    { name: 'STAFF AND PAYROLL', value: 'staff' },
    { name: 'REPORTS', value: 'reports' },
    { name: 'SETTINGS', value: 'settings' },
    { name: 'INVENTORY EDIT', value: 'inventory_edit' },
    { name: 'INVENTORY DELETE', value: 'inventory_delete' },
    { name: 'INVOICE EDIT', value: 'sales_edit' },
    { name: 'INVENTORY TOP UP', value: 'inventory_topup' },
];
// All the Features 

export const clients = [
    justrite, justrite,
    justrite, justrite,

];
export const products = [
    {
        img: renimail,
        url: 'https://renitrust.com',
        title: 'RENIMAIL',
        content: 'Experience the power of our comprehensive email marketing platform called ReniMail. Send personalized emails, launch impactful campaigns, and reach your audience with precision and ease. Elevate your marketing strategy and connect with customers in a whole new way.'
    },
    {
        img: renitrust,
        url: 'https://renimail.com',
        title: 'RENITRUST',
        content: 'ReniTrust is a comprehensive online platform that facilitates seamless financial transactions, including bill payments, secure escrow services, and effortless payment link creation. Empowering you with a secure and efficient way to manage your finances and engage in monetary exchanges with confidence and trust.'
    },
    {
        img: renistore,
        url: 'https://reni.store',
        title: 'RENISTORE',
        content: 'Reni Store is an e-commerce platform with a dynamic retail process that carries a vast selection of products, including those for personal care, mobile devices, fashion, and more. The store experience is optimised to provide shoppers with a sense of control and decisiveness. Our escrow system supports the online store, making all transactions risk-free.'
    },
];
export const offer = [
    {
        icon: ICON_BANK,
        title: 'Inventory Management',
        content: 'Optimize your business with efficient inventory management – streamline stock control, reduce waste, and boost profitability.'
    },
    {
        icon: ICON_BANK,
        title: 'Business Banking',
        content: 'Discover benefits of business banking and streamline your finances and boost your business with our tailored banking solutions.'
    },
    {
        icon: ICON_BANK,
        title: 'Debt Management',
        content: 'Keep track of debit, credit records, and take control of your finances to secure your financial future.'
    },
    {
        icon: ICON_BANK,
        title: 'Invoicing',
        content: 'Streamline your billing process, create professional invoices and grow your business by optimizing your sales documentation.'
    },
    {
        icon: ICON_BANK,
        title: 'Payroll Management',
        content: 'Streamline employee compensation with our payroll solution, ensuring accurate and timely payments while minimizing administrative burden.'
    },
    {
        icon: ICON_BANK,
        title: 'Financial Reports',
        content: 'Get a snapshot of your financial health, performance, and unlock insights, informed decisions with our concise financial reports.'
    },
];

export const homeGetStarted = [
    {
        title: "Account Creation",
        content: "Click on “Get Started” to create an account with us."
    },
    {
        title: "Account Activation",
        content: "Verify your details with us to get validated as a user."
    },
    {
        title: "Business Setup",
        content: "Begin your journey to a seamless finance management."
    },
];
// Homepage

// dashboard
export const itemHistory = [
    {
        name: '  Surf Excel',
        soldQuantity: 30,
        remQuantity: 30,
        price: 200,
    },
    {
        name: '  Surf Excel',
        soldQuantity: 30,
        remQuantity: 30,
        price: 200,
    },
    {
        name: '  Surf Excel',
        soldQuantity: 30,
        remQuantity: 30,
        price: 200,
    },
];
// dashboard

// inventory
export const allInventory = [
    { id: '1', batch_no: 'Bat12', item_name: 'Maggi', cost_price: 1000, selling_price: 2000, qty: 3, unit: '', expiry_date: '77-77-8979', timeago: '12-12-9080 ' },
    { id: '1', batch_no: 'Bat12', item_name: 'Maggi', cost_price: 1000, selling_price: 2000, qty: 3, unit: '', expiry_date: '77-77-8979', timeago: '12-12-9080 ' },
    { id: '1', batch_no: 'Bat12', item_name: 'Maggi', cost_price: 1000, selling_price: 2000, qty: 3, unit: '', expiry_date: '77-77-8979', timeago: '12-12-9080 ' },
    { id: '1', batch_no: 'Bat12', item_name: 'Maggi', cost_price: 1000, selling_price: 2000, qty: 3, unit: '', expiry_date: '77-77-8979', timeago: '12-12-9080 ' },
];
// inventory

// item
export const allItem = [
    { id: '1', batch_no: 'Bat12', item_name: 'Maggi', expiry_date: '77-77-8979', timeago: '12-12-9080 ' },
    { id: '1', batch_no: 'Bat12', item_name: 'Maggi', expiry_date: '77-77-8979', timeago: '12-12-9080 ' },
    { id: '1', batch_no: 'Bat12', item_name: 'Maggi', expiry_date: '77-77-8979', timeago: '12-12-9080 ' },
    { id: '1', batch_no: 'Bat12', item_name: 'Maggi', expiry_date: '77-77-8979', timeago: '12-12-9080 ' },
];
// item

// expenses
export const allExpenses = [
    { id: '1', category: 'Transport', details: 'Travels', supplier: 'John Doe', amount: '22,000', timeago: '12-12-9080 ' },
    { id: '1', category: 'Transport', details: 'Travels', supplier: 'John Doe', amount: '22,000', timeago: '12-12-9080 ' },
    { id: '1', category: 'Transport', details: 'Travels', supplier: 'John Doe', amount: '22,000', timeago: '12-12-9080 ' },
    { id: '1', category: 'Transport', details: 'Travels', supplier: 'John Doe', amount: '22,000', timeago: '12-12-9080 ' },

];
// expenses

// customer
export const allCustomers = [
    { id: '1', name: 'Transport', phone: 'Travels', email: 'John Doe', timeago: '12-12-9080 ' },
    { id: '1', name: 'Transport', phone: 'Travels', email: 'John Doe', timeago: '12-12-9080 ' },
    { id: '1', name: 'Transport', phone: 'Travels', email: 'John Doe', timeago: '12-12-9080 ' },
    { id: '1', name: 'Transport', phone: 'Travels', email: 'John Doe', timeago: '12-12-9080 ' },

];
// customer

// supplier
export const allSuppliers = [
    { id: '1', name: 'Transport', phone: 'Travels', email: 'John Doe', timeago: '12-12-9080 ' },
    { id: '1', name: 'Transport', phone: 'Travels', email: 'John Doe', timeago: '12-12-9080 ' },
    { id: '1', name: 'Transport', phone: 'Travels', email: 'John Doe', timeago: '12-12-9080 ' },
    { id: '1', name: 'Transport', phone: 'Travels', email: 'John Doe', timeago: '12-12-9080 ' },

];

export const allDebtors = [
    { id: '1', name: 'Transport', phone: 'Travels', amount: 'John Doe', timeago: '12-12-9080 ' },
    { id: '1', name: 'Transport', phone: 'Travels', amount: 'John Doe', timeago: '12-12-9080 ' },
    { id: '1', name: 'Transport', phone: 'Travels', amount: 'John Doe', timeago: '12-12-9080 ' },
    { id: '1', name: 'Transport', phone: 'Travels', amount: 'John Doe', timeago: '12-12-9080 ' },

];

export const allInvoice = [
    { id: '1', name: 'Transport', phone: 'Travels', amount: 'John Doe', timeago: '12-12-9080 ' },
    { id: '1', name: 'Transport', phone: 'Travels', amount: 'John Doe', timeago: '12-12-9080 ' },
    { id: '1', name: 'Transport', phone: 'Travels', amount: 'John Doe', timeago: '12-12-9080 ' },
    { id: '1', name: 'Transport', phone: 'Travels', amount: 'John Doe', timeago: '12-12-9080 ' },

];

export const allBilling = [
    { id: '1', active: true, amount: '10,000', duration_days: '29', time_date: '12-12-9080 ', expire_date: '12-12-2000', package_name: 'Free Tier' },
    { id: '1', active: false, amount: '10,000', duration_days: '29', time_date: '12-12-9080 ', expire_date: '12-12-2000', package_name: 'Free Tier' },
    { id: '1', active: false, amount: '10,000', duration_days: '29', time_date: '12-12-9080 ', expire_date: '12-12-2000', package_name: 'Free Tier' },
    { id: '1', active: false, amount: '10,000', duration_days: '29', time_date: '12-12-9080 ', expire_date: '12-12-2000', package_name: 'Free Tier' },


];
export const allStaff = [
    { id: '1', name: 'Akin Loye', email: 'akin@mial.com', positon: 'CEO ', img: '' },
    { id: '1', name: 'Akin Loye', email: 'akin@mial.com', positon: 'CEO ', img: '' },
    { id: '1', name: 'Akin Loye', email: 'akin@mial.com', positon: 'CEO ', img: '' },
    { id: '1', name: 'Akin Loye', email: 'akin@mial.com', positon: 'CEO ', img: '' },



];

export const lowStocky = [
    { img: lowstock, title: 'Tata Salt', rem: '10' },
    { img: lowstock, title: 'Tata Salt', rem: '10' },
    { img: lowstock, title: 'Tata Salt', rem: '10' },
];

export const itemType = [
    {
        name: 'Product',
        value: 'product'
    },
    {
        name: 'Services',
        value: 'service'
    },
];

export const allGender = [
    {
        name: 'Male',
        value: 'male'
    },
    {
        name: 'Female',
        value: 'female'
    },
];
export const vatType = [
    {
        name: 'Inclusive',
        value: 'inclusive'
    },
    {
        name: 'Exclusive',
        value: 'exclusive'
    },
];

// reports

export const allMonth = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
];
export const allYear = [
    '2024', '2025', '2026'
];






export const naira = '₦';

export const namePlaceholder = 'e.g Jane Doe';
export const emailPlaceholder = 'e.g jane@mail.com';
export const phonePlaceholder = 'e.g 08012345678';
export const amountPlaceholder = 'e.g 1000';
export const passwordPlaceholder = '**********';

export const PASSWORD_REGEX = /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*()\-=_+{};':"\\|,.<>/?`~\[\]])[a-zA-Z\d!@#$%^&*()\-=_+{};':"\\|,.<>/?`~\[\]]{7,}$/;

export const EMAIL_REGEX = /^(?![_.-])((?![_.-][_.-])[a-zA-Z\d_.-]){0,63}[a-zA-Z\d]@((?!-)((?!--)[a-zA-Z\d-]){0,63}[a-zA-Z\d]\.){1,2}([a-zA-Z]{2,14}\.)?[a-zA-Z]{2,14}$/;

export const CARD_REGEX = /^\d{16}$/;

export const CVV_REGEX = /^\d{3,4}$/;

export const MONTH_REGEX = /^(0[1-9]|1[0-2])$/;

export const YEAR_REGEX = /^([0-9]{2})$/;

export const URL_REGEX = /\b(?:https?|ftp):\/\/[^\s/$.?#].[^\s]*\b/;

export const PIN_REGEX = /^\d{4}$/;
// 62417411089